import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ApiClients } from '@/api/client';
import type { components } from '@/api/types/api-gateway';

// S16 — Org settings. Reuses S13's useOrg for reads.

export type OrgPatchRequest = components['schemas']['OrgPatchRequest'];

export function usePatchOrg(clients: ApiClients) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: OrgPatchRequest) => {
      const { data, error } = await clients.apiGateway.PATCH('/v1/orgs/current', {
        body: vars,
      });
      if (error) throw new Error('save org failed');
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['org'] }),
  });
}
